<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <modal-send-user-log :callCheckRequest="callCheckRequest"/>
    <modal-change-code :newUserCode.sync="newUserCode" :dataModal="dataModal"/>
    <modal-change-retroactive-shift :reloadUserInfo.sync="reloadUserInfo" :dataModal="dataModal"
                                    :changeOrUpdate="changeOrUpdate"/>
    <modal-default modal-title="Alterar câmera" modal-id="changeCamera">
      <input-text type="number" :is-required="true" col="0" label="Número da câmera:" placeholder="Digite o número"
                  @contentText="value => this.updateCameraNumber = value"/>
      <p><span>1: Câmera primária</span>, <span>2: Câmera secundária</span>, <span>3: Câmera terciária</span>.</p>
      <btn-custom @emit-click="changeCameraNumber" label="Salvar" which-side="right" col="0"/>
    </modal-default>

    <section>
      <page-header v-if="!loading" :headerName="'Usuário: ' + dataUser.name" :showBtn="false" :btnName="''"
                   :btnRoute="''" :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- Detail user -->
            <div v-if="!loading" class="col-md-12">
              <div class="col-md-12 default-box box-user">
                <div class="col-md-2">
                  <div class="user-pic">
                    <img v-if="dataUser.photo" v-bind:src="dataUser.photo" class="img-responsive" alt="Usuário">
                    <img src="../../../../../assets/img/user-default.png" class="img-responsive" alt="Usuário" v-else>
                    <p v-if="dataUser.lastAcess">Último Acesso: <span>{{ dataUser.lastAcess }}</span></p>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="detail">
                    <p class="name">{{ dataUser.name }} - <span>{{ dataUser.email }}</span></p>
                    <div class="col-md-6 padding-null">
                      <p>Data de Admissão: <span>{{ dataUser.admissionDate | formatDate }}</span></p>
                      <p>Código: #<span>{{ dataUser.code }}</span></p>
                      <p>Ativo:
                        <span>
                        <span v-if="dataUser.active">SIM</span>
                        <span v-else>NÃO</span>
                      </span>
                      </p>
                      <div class="box-change-camera">
                        <p>Camera: <span>{{ dataUser.appCameraNumber }}</span></p>
                        <button class="btn-camera" @click="openModalChangeCamera">Alterar</button>
                      </div>
                      <p>Último login: <span>{{ dataUser.lastLogin | formatDate }}</span></p>
                      <p>Tem multiplo login? <span>{{ dataUser.hasMultipleLogins ? 'SIM' : 'NÃO' }}</span></p>
                      <p>Data admissão MarQ: <span>{{ dataUser.marQAdmissionDate | formatDate }}</span></p>
                    </div>

                    <div class="col-md-6 padding-null">
                      <p v-if="dataUser.personalInfo.cpf">CPF: <span>{{ dataUser.personalInfo.cpf }}</span></p>
                      <p v-if="dataUser.personalInfo.rg">RG: <span>{{ dataUser.personalInfo.rg }}</span></p>
                      <p v-if="dataUser.personalInfo.pis">PIS: <span>{{ dataUser.personalInfo.pis }}</span></p>
                      <p>Telefone:
                        <span>
                        <span>{{ dataUser.phone.cellPhoneNumber }}</span>
                        <span v-if="dataUser.phone.cellPhoneNumber && dataUser.phone.phoneNumber">-</span>
                        <span>{{ dataUser.phone.phoneNumber }}</span>
                      </span>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="action">
                    <h4>Ações</h4>

                    <div class="col-md-6 padding-null">
                      <button v-on:click="resetPassword()" class="reset">
                        <div v-if="loadingReset" class="loading-btn">
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                        <span v-else>Resetar Senha</span>
                      </button>
                    </div>

                    <div class="col-md-6 padding-null">
                      <button v-on:click="sendRecovery()" class="recovery">
                        <div v-if="loadingRecovery" class="loading-btn">
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                        <span v-else>Esqueci Senha</span>
                      </button>
                    </div>

                    <div class="col-md-6 padding-null">
                      <button v-on:click="changeUserCode()" class="change-code">
                        <span>Alterar Código</span>
                      </button>
                    </div>

                    <div class="col-md-6 padding-null">
                      <button v-on:click="forceLogout()" class="logout-user">
                        <span v-if="!loadingUserLogout">Forçar Logout</span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                    <div class="col-md-6 padding-null">
                      <button v-on:click="modalDelDays()" class="logout-user logout-user-height background-red">
                        <span>Exclusão de dias</span>
                      </button>
                    </div>
                    <div class="col-md-6 padding-null">
                      <button v-on:click="sendLogNotification()" class="logout-user logout-user-height">
                        <span>Notificação de Log</span>
                      </button>
                    </div>

                    <!--<div v-if="dataUser.workShift.workShiftType === 2" class="col-md-12 padding-null">-->
                    <!--<button v-on:click="changeWorkShift()" class="change-code">-->
                    <!--<span>Trocar turno retroativo</span>-->
                    <!--</button>-->
                    <!--</div>-->

                    <div v-if="dataUser.workShift.workShiftType === 2" class="col-md-12 padding-null">
                      <button v-on:click="attWorkShift()" class="change-code">
                        <span>Atualizar turno retroativo</span>
                      </button>
                    </div>

                    <div v-if="!dataUser.active" class="col-md-12 padding-null">
                      <button v-on:click="reactiveUser()" class="reactive-user">
                        <div v-if="loadingReactive" class="loading-btn">
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                        <span v-else>Reativar Funcionário</span>
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="modal fade" id="del-days-modal" role="dialog">
        <div class="modal-dialog">
          <div class="modal-dialog">
            <div class="modal-content content">
              <div class="modal-header">
                <a type="button" class="close-btn-password" data-dismiss="modal">
                  <ion-icon name="close"></ion-icon>
                </a>
                <div class="title-group">
                  <ion-icon name="create-outline"></ion-icon>
                  <h4 class="title-modal">Excluir dias do inicio até:</h4>
                </div>
                <div class="subtitle">
                  <span>Exclusão de dias do PRIMEIRO DIA até a data especificada</span>
                </div>
              </div>
              <div class="modal-body">
                <div class="input-data-days">
                  <div class="datepicker-group">
                    <datepicker v-model="dataToDel" :language="ptBR" input-class="datepicker-style"
                                :format="customFormatter"
                                placeholder="DD/MM/YYYY"/>
                    <i class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                  <button class="btn-validate" @click="delUserDays()" data-dismiss="modal"
                          data-backdrop="false">
                    <span v-if="!loadingDelUser">Confirmar</span>
                    <div class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import pageHeader from "../../../components/default/pageHeader.vue";
import swal from 'sweetalert';

import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from 'vuejs-datepicker';

import {
  USER_PERFIL,
  RESET_PASS,
  FORGOT_PASS,
  USER_LOGOUT,
  REACTIVE_USER, UPDATE_INVOICES, DELETE_USER_DAYS, CHANGE_CAMERA_NUMBER,
} from "../../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../../requestConfig";
import modalChangeCode from "../../../modals/modalChangeCode";
import modalChangeRetroactiveShift from "../../../modals/modalChangeRetroactiveShift";
import ModalSendUserLog from "../../../modals/modalSendUserLog";
import moment from "moment";
import ModalDefault from "../../../components/modals/modalDefault.vue";
import inputText from "../../../components/inputs/inputText.vue";
import BtnCustom from "../../../components/buttons/btnCustom.vue";

export default {
  name: "user-profile",
  components: {
    BtnCustom,
    ModalDefault,
    ModalSendUserLog,
    modalChangeCode,
    modalChangeRetroactiveShift,
    topMenu,
    pageHeader,
    fullLoading,
    datepicker,
    inputText
  },
  data() {
    return {
      ptBR: ptBR,
      callCheckRequest: '',
      context: this.$route.params.type,
      changeOrUpdate: 0,
      dataModal: '',
      newUserCode: '',
      reloadUserInfo: '',
      loading: true,
      loadingReactive: false,
      loadingRecovery: false,
      loadingReset: false,
      loadingUserLogout: false,
      loadingDelUser: false,
      updateCameraNumber: 0,
      dataUser: {
        personalInfo: {},
        phone: {},
        workShift: {}
      },
      dataToDel: ''
    }
  },
  methods: {
    openModalChangeCamera() {
      $('#changeCamera').modal();
    },
    changeCameraNumber() {
      let url = CHANGE_CAMERA_NUMBER + '?userId=' + this.dataUser.id;
      if (this.updateCameraNumber) {
        url += '&cameraNumber=' + this.updateCameraNumber;

        REQUEST_SERVICE.get(url).then(response => {
          UTIL_SERVICE.console('RESULT CHANGE_CAMERA_NUMBER', response.data);
          swal('Aviso', 'Alterado com sucesso!');
          $('#changeCamera').modal('hide');
          this.getUser();
        }).catch((reason) => {
          $('#changeCamera').modal('hide');
          swal('Erro', reason.response.data);
        })
      } else {
        $('#changeCamera').modal('hide');
        swal('Alerta!', 'Preencha o campo para finalizar a tarefa.');
      }
    },
    getUser() {
      this.loading = true;

      REQUEST_SERVICE.requestContext('GET', USER_PERFIL + "?t=kkkk&i=" + this.$route.params.value, this.$route.params.type)
        .then((response) => {
          UTIL_SERVICE.console("RESULT USER_PERFIL:", response.data);

          if (response.data)
            this.dataUser = response.data;

          this.loading = false;
        }).catch((reason) => {
        this.loading = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    resetPassword() {
      this.loadingReset = true;
      REQUEST_SERVICE.requestContext('GET', RESET_PASS + "?t=kkkk&i=" + this.$route.params.value, this.$route.params.type)
        .then((response) => {
          UTIL_SERVICE.console("RESULT RESET_PASS:", response.data);

          swal("Aviso", response.data, "success");
          this.loadingReset = false;
        }).catch((reason) => {
        this.loadingReset = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    sendRecovery() {
      this.loadingRecovery = true;
      REQUEST_SERVICE.requestContext('GET', FORGOT_PASS + "?t=kkkk&i=" + this.$route.params.value, this.$route.params.type)
        .then((response) => {
          UTIL_SERVICE.console("RESULT FORGOT_PASS:", response.data);

          swal("Aviso", response.data, "success");
          this.loadingRecovery = false;
        }).catch((reason) => {
        this.loadingRecovery = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    reactiveUser() {
      this.loadingReactive = true;
      REQUEST_SERVICE.requestContext('GET', REACTIVE_USER + "?usersId=" + this.$route.params.value, this.$route.params.type)
        .then((response) => {
          UTIL_SERVICE.console("RESULT REACTIVE_USER:", response.data);

          swal("Aviso", response.data, "success");
          this.loadingReactive = false;
        }).catch((reason) => {
        this.loadingReactive = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    sendLogNotification() {
      this.callCheckRequest = {
        random: Math.floor(Math.random() * 500),
        dtUser: this.dataUser,
        context: this.context
      };

      $("#modalSendUserLog").modal();
    },
    modalDelDays() {
      $("#del-days-modal").modal();
    },
    delUserDays() {
      this.loadingDelUser = true;
      this.dataToDel = moment(this.dataToDel).format('YYYY-MM-DD');

      let obj = {
        id: this.dataUser.id,
        date: this.dataToDel,
        confirm: false
      }

      UTIL_SERVICE.console("DATA SEND:", obj);
      REQUEST_SERVICE.requestContext("PUT", DELETE_USER_DAYS, this.$route.params.type, obj)
        .then((response) => {
          UTIL_SERVICE.console("RESULT DELETE_USER_DAYS:", response.data);

          const returnValue = response.data

          if (returnValue.hasPendingActions === true) {

            swal("Tem certeza que deseja excluir os dias para o colaborador que possui pontos nesse periodo?", {
              buttons: {
                cancel: "Cancelar",
                confirm: {
                  text: "Confirmar",
                  value: "confirmed"
                }
              },
            })
              .then((value) => {
                switch (value) {

                  case "confirmed":
                    obj.confirm = true

                    UTIL_SERVICE.console("DATA SEND:", obj);
                    REQUEST_SERVICE.requestContext("PUT", DELETE_USER_DAYS, this.$route.params.type, obj)
                      .then((response) => {
                        UTIL_SERVICE.console("RESULT DELETE_USER_DAYS:", response.data);
                        this.loadingDelUser = false;
                        this.dataToDel = ''

                        swal("Sucesso!", "Excluído com sucesso!", "success");
                      })
                      .catch((reason) => {
                        this.loadingDelUser = false;
                        swal("Erro!", "Error!", "error");
                      });
                    break;

                  default:
                    swal("Cancelado!", "Exclusão cancelada!", "error");
                }
              });

          } else {
            this.dataToDel = ''
            swal("Sucesso!", "Excluído com sucesso!", "success");
          }

          this.loadingDelUser = false;
        })
        .catch((reason) => {
          this.loadingDelUser = false;

          swal("Erro!", "Error!", "error");
        });
    },
    changeUserCode() {
      this.dataModal = this.dataUser;

      $("#modalChangeCode").modal();
    },
    forceLogout() {
      this.loadingUserLogout = true;
      REQUEST_SERVICE.requestContext('GET', USER_LOGOUT + "?i=" + this.$route.params.value, this.$route.params.type)
        .then((response) => {
          UTIL_SERVICE.console("RESULT USER_LOGOUT:", response.data);

          swal("Aviso", response.data, "success");
          this.loadingUserLogout = false;
        }).catch((reason) => {
        this.loadingUserLogout = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    changeWorkShift() {
      this.dataModal = this.dataUser;
      this.changeOrUpdate = 1;

      $("#modalChangeRetroactiveShift").modal();
    },
    attWorkShift() {
      this.dataModal = this.dataUser;
      this.changeOrUpdate = 2;

      $("#modalChangeRetroactiveShift").modal();
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
  beforeMount() {
    this.getUser();
  },
  watch: {
    newUserCode: function (value) {
      this.dataUser.code = value;
    },
    reloadUserInfo: function (value) {
      this.getUser();
    }
  }
}
</script>

<style lang="scss">

.logout-user-height {
  height: 53px !important;
}

.background-red {
  background: var(--light-red) !important;

  &:hover {
    background: #ca2238 !important;
  }
}

.swal-overlay {
  .swal-modal {
    .swal-text {
      text-align: center;
    }
  }
}

.box-change-camera {
  display: flex;
  align-items: start;
  gap: 8px;

  .btn-camera {
    border-radius: 4px !important;
    font-weight: 600;
    text-align: center;
    border: 1px solid #3598DC;
    background: #fff;
    font-size: 12px;
    line-height: 16px;

    &:hover {
      border: 1px solid #23527C;
      color: #23527C;
    }
  }
}

#del-days-modal {
  .modal-dialog {
    width: 500px;
    margin-top: 15%;

    .content {
      border: none;
      box-shadow: none;
      border-radius: 8px !important;

      .modal-header {
        position: relative;
        padding: 20px 30px;
        border-bottom: none;

        .title-group {
          display: flex;
          align-items: flex-end;

          ion-icon {
            margin-right: 5px;
            font-size: 23px;
            color: var(--dark-gray);
          }

          .title-modal {
            margin: 0;
            text-align: left;
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: 700;
            color: var(--classic-black);
          }
        }

        .subtitle {
          span {
            margin-top: 5px;
            margin-left: 4px;
            font-size: 14px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }

        .close-btn-password {
          position: absolute;
          right: 26px;
          top: 16px;
          height: 20px;
          color: var(--light-red);

          &:hover {
            color: var(--high-red);
          }

          ion-icon {
            font-size: 20px;
            pointer-events: none;
          }
        }
      }

      .modal-body {
        padding: 0 30px 20px;

        .input-data-days {
          display: flex;
          position: relative;
          justify-content: space-between;

          .datepicker-group {
            position: relative;

            .vdp-datepicker {
              display: inline-block;
              width: 100%;

              .datepicker-style {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;

                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }

            i {
              position: absolute;
              right: 15px;
              top: 11px;
              color: #111;
              cursor: pointer;
            }
          }
        }

        .btn-validate {
          background: #2F23D6;
          color: #ffffff;
          border-radius: 4px !important;
          border: none;
          padding: 0 20px;

          &:hover {
            background: #20179e;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/user/userProfile/userProfile.vue